import './frontend.scss';
import "./js/animations/usingIntersectionObserver";

//Parallax
import "./js/parallax/logic";